import PopUp, { PopUpTypes } from './PopUp';

export default PopUp
export type { PopUpTypes }